import React from 'react';
import { IconProps } from '.';

const SvgBoxEyeOffFill = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path fill={color} d='M2 5a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5Z' />
      <path
        fill='#fff'
        d='M18.364 7.776 17.549 7 6.91 17.218l.808.782 1.96-1.882a7.648 7.648 0 0 0 2.323.354c3.182 0 5.9-1.9 7-4.583a7.19 7.19 0 0 0-2.03-2.775l1.394-1.338ZM12 10.056a1.95 1.95 0 0 0-1.35.537c-.358.343-.56.81-.56 1.296 0 .214.04.422.11.611l2.436-2.34a1.981 1.981 0 0 0-.636-.104Zm0-2.75c-3.182 0-5.9 1.9-7 4.583a7.25 7.25 0 0 0 2.545 3.172l.904-.874a6.105 6.105 0 0 1-2.062-2.298C7.437 9.836 9.607 8.528 12 8.528c.694 0 1.374.11 2.01.305l.98-.935A7.818 7.818 0 0 0 12 7.306Zm5.613 4.583c-1.05 2.053-3.22 3.361-5.613 3.361a6.15 6.15 0 0 1-1.273-.128l1.451-1.4c.91-.091 1.636-.788 1.731-1.662l2.164-2.084a6.06 6.06 0 0 1 1.54 1.913Z'
      />
    </svg>
  );
};

export default SvgBoxEyeOffFill;
